import React from 'react'
import Layout from '../../components/layout'

const PrivacyPage = () => {
  return (
    <Layout heading="Privacy">
      <h1>Jobcast Privacy Policy</h1>
      <p>Effective Date: May 25, 2018</p>
      <p>
        This policy explains what information we collect when you use
        Jobcast’s site, services, mobile applications, products, and
        content (“Services”). It also has information about how we
        store, use, transfer, and delete that information.
      </p>
      <h4>Information We Collect &amp; How We Use It</h4>
      <p>
        Jobcast doesn’t collect data in order to advertise to our
        users. The tracking we do at Jobcast is to make our product
        work as well as possible.
      </p>
      <p>
        In order to give you the best possible experience using
        Jobcast, we collect information from your interactions with
        our network. Some of this information, you actively tell us
        (such as your email address, which we use to track your
        account or communicate with you). Other information, we
        collect based on actions you take while using Jobcast,
        includes your Internet Protocol address and information about
        your device (such as device or browser type).
      </p>
      <p>We use this information to:</p>
      <ul>
        <li>
          <p>
            provide, test, improve, promote and personalize Jobcast
            Services
          </p>
        </li>
        <li>
          <p>fight spam and other forms of abuse</p>
        </li>
        <li>
          <p>
            generate aggregate, non-identifying information about how
            people use Jobcast Services
          </p>
        </li>
      </ul>
      <p>
        When you create your Jobcast account, and authenticate/connect
        with a third-party service (like Twitter, Facebook or
        LinkedIn) we may collect, store, and periodically update
        information associated with that third-party account, like
        your Facebook page or Group name. We will never publish
        through your third-party account without your permission.
      </p>
      <h4>Use of Facebook / Meta Platform Data</h4>
      <p>
        Jobcast may integrate with Meta platforms, including Facebook
        Login and the Facebook Graph API, to provide authentication and
        related functionality.
      </p>
      <p>
        When a user authenticates using Facebook Login, we may receive
        limited information from Facebook, which can include:
      </p>
      <ul>
        <li><p>Name</p></li>
        <li><p>Email address</p></li>
        <li><p>Facebook user ID</p></li>
        <li><p>Profile picture (if authorized)</p></li>
      </ul>
      <p>We use this information solely to:</p>
      <ul>
        <li><p>Authenticate users</p></li>
        <li><p>Create or link user accounts</p></li>
        <li><p>Provide requested functionality</p></li>
      </ul>
      <p>We do not sell Facebook-derived data.</p>
      <p>
        We do not share Facebook user data with third parties except as
        necessary to provide our services or as required by law.
      </p>
      <p>
        All Facebook data is handled in accordance with Meta Platform
        Terms and Meta Platform Policies.
      </p>
      <p>
        Jobcast also uses the Facebook Graph API to publish posts to
        Facebook Pages and Facebook user profiles on behalf of users
        and companies who explicitly authorize this functionality. Posts
        are only created at the direction of the user.
      </p>
      <p>
        Users may revoke all Facebook permissions at any time through
        their Facebook account settings or by disconnecting their
        Facebook account within Jobcast.
      </p>
      <h4>Information Disclosure</h4>
      <p>
        Jobcast won’t transfer information about you to third parties
        for the purpose of providing or facilitating third-party
        advertising to you. We won’t sell information about you.
      </p>
      <p>
        We may share your account information with third parties in
        some circumstances, including: (1) with your consent; (2) when
        we have a good faith belief it is required by law, such as
        pursuant to a subpoena or other legal process; (3) when we
        have a good faith belief that doing so will help prevent
        imminent harm to someone.
      </p>
      <p>
        If we are going to share your information in response to a
        legal process, we’ll give you notice so you can challenge it
        (for example by seeking court intervention), unless we’re
        prohibited by law or believe doing so may endanger others. We
        will object to requests for information about users of our
        services that we believe are improper.
      </p>
      <h4>Data Storage</h4>
      <p>
        Jobcast uses third-party vendors and hosting partners, such as
        Calligo Canada, for hardware, software, networking, storage,
        and related technology we need to run Jobcast. We maintain two
        types of temporary logs: server logs and user event logs. By
        using Jobcast Services, you authorize Jobcast to transfer,
        store, and use your information in Canada and any other
        country where we operate.
      </p>
      <h4>Third-Party Embeds</h4>
      <p>
        Some of the content that you see displayed on Jobcast is not
        hosted by Jobcast. These “embeds” are hosted by a third-party
        and embedded in Jobcast. For example YouTube or Vimeo videos,
        Imgur or Giphy gifs, SoundCloud audio files, Twitter tweets,
        GitHub code, or Scribd documents that appear in a Jobcast
        post. These files send data to the hosted site just as if you
        were visiting that site directly (for example, when you load a
        Jobcast post page with a YouTube video embedded in it, YouTube
        receives data about your activity). Jobcast does not control
        what data third parties collect in cases like this, or what
        they will do with it. So, third-party embeds on Jobcast are
        not covered by this privacy policy. They are covered by the
        privacy policy of the third-party service.
      </p>
      <p>
        Some embeds may ask you for personal information, such as your
        email address, through a form. We do our best to keep bad
        actors off of Jobcast. However, if you choose to submit your
        information to a third party this way, we don’t know what they
        may do with it. As explained above, their actions are not
        covered by this Privacy Policy. So, please be careful when you
        see embedded forms on Jobcast asking for your email address or
        any other personal information. Make sure you understand who
        you are submitting your information to and what they say they
        plan to do with it. We suggest that you do not submit personal
        information to any third-party through an embedded form.
      </p>
      <p>
        If you embed a form that allows submission of personal
        information by users, you must provide near the embedded form
        a prominent link to an applicable Privacy Policy that clearly
        states how do you intend to use any information collected.
        Failure to do so may lead Jobcast to disable the post or take
        other action to limit or disable your account.
      </p>
      <h4>Tracking &amp; Cookies</h4>
      <p>
        We use browser cookies and similar technologies to recognize
        you when you return to our Services. We use them in various
        ways, for example, to log you in, remember your preferences
        (such as default language), evaluate email effectiveness,
        allow our paywall and meter to function, and personalize
        content and other information.
      </p>
      <p>
        Jobcast doesn’t track you across the Internet. We track only
        your interactions within the Jobcast network (which
        encompasses Jobcast.net and custom domains hosted by Jobcast).
      </p>
      <p>
        Some third-party services that we use to provide the Jobcast
        Service, such as Google Analytics, may place their own cookies
        in your browser. This Privacy Policy covers the use of cookies
        by Jobcast only and not the use of cookies by third parties.
      </p>
      <h4>Modifying or Deleting Your Personal Information</h4>
      <p>
        If you have a Jobcast account, you can access and modify your
        personal information, or delete your account{' '}
        <a href="https://app.jobcast.net/dashboard/profile/deleteaccount">
          here
        </a>
        .
      </p>
      <p>
        To protect information from accidental or malicious
        destruction, we may maintain residual copies for a brief time
        period. But, if you delete your account, your information and
        content will be unrecoverable after that time. Jobcast may
        preserve and maintain copies of your information when required
        to do so by law.
      </p>
      <h4>Data Security</h4>
      <p>
        We use encryption (HTTPS/TLS) to protect data transmitted to
        and from our site. However, no data transmission over the
        Internet is 100% secure, so we can’t guarantee security. You
        use the Service at your own risk, and you’re responsible for
        taking reasonable measures to secure your account.
      </p>
      <h4>Business Transfers</h4>
      <p>
        If we are involved in a merger, acquisition, bankruptcy,
        reorganization or sale of assets such that your information
        would be transferred or become subject to a different privacy
        policy, we’ll notify you in advance so you can opt out of any
        such new policy by deleting your account before transfer.
      </p>
      <h4>Email from Jobcast</h4>
      <p>
        Sometimes we’ll send you emails about your account, service
        changes or new policies. You can’t opt out of this type of
        “transactional” email (unless you delete your account). But,
        you can opt out of non-administrative emails such as digests,
        newsletters, and activity notifications through your account’s
        “Settings” page
      </p>
      <p>
        When you interact with an email sent from Jobcast (such as
        opening an email or clicking on a particular link in an
        email), we may receive information about that interaction. We
        won’t email you to ask for your password or other account
        information. If you receive such an email, please send it to
        us so we can investigate.
      </p>
      <h3>Data Protection Statement for European Union Users</h3>
      <h4>Description of Processing Activity</h4>
      <p>
        Jobcast collects and stores personal information about its
        users to customize their reading experience and enable
        personalized distribution of content. It shares minimal data
        with its service providers.
      </p>
      <h4>Purposes of Processing</h4>
      <ul>
        <li>
          <p>Provide, test, promote, and improve the services</p>
        </li>
        <li>
          <p>Gather usage statistics of services</p>
        </li>
        <li>
          <p>Fight spam, fraud, and other abuse of services</p>
        </li>
      </ul>
      <h4>Legal Bases</h4>
      <p>
        In order to provide the services, Jobcast collects and stores
        personal data about its users on the legal basis of consent
        given when you create an account and agree to the Privacy
        Policy.
      </p>
      <h4>Categories of Personal Data Collected</h4>
      <p>Logged out users (blog)</p>
      <ul>
        <li>
          <p>Reading history</p>
        </li>
        <li>
          <p>IP address</p>
        </li>
        <li>
          <p>Browser information</p>
        </li>
        <li>
          <p>DNT status</p>
        </li>
      </ul>
      <p>Logged in users:</p>
      <ul>
        <li>
          <p>Username</p>
        </li>
        <li>
          <p>Display name</p>
        </li>
        <li>
          <p>Bio</p>
        </li>
        <li>
          <p>Pictures</p>
        </li>
        <li>
          <p>Email address</p>
        </li>
        <li>
          <p>Session activity</p>
        </li>
        <li>
          <p>Linked social media accounts</p>
        </li>
        <li>
          <p>IP address</p>
        </li>
        <li>
          <p>Browser information</p>
        </li>
        <li>
          <p>Reading history (on Jobcast network only)</p>
        </li>
        <li>
          <p>Network interactions (recommends, follows, etc.)</p>
        </li>
        <li>
          <p>Billing information and history</p>
        </li>
      </ul>
      <h4>Categories of Recipients</h4>
      <p>
        Jobcast shares minimal personal data with third-party
        processors in order to provide the Services. These processors
        offer at least the same level of data protection as that set
        out in this statement. This includes the following categories
        of recipients:
      </p>
      <ul>
        <li>
          <p>Hosting, Storage, &amp; Other Infrastructure</p>
        </li>
        <li>
          <p>Security</p>
        </li>
        <li>
          <p>Communication &amp; Support</p>
        </li>
        <li>
          <p>Payment Processors</p>
        </li>
      </ul>
      <p>
        Search engines will index user profiles, public interactions,
        and any user-generated content. Users may also share links to
        your content on social media.
      </p>
      <h4>Payment Processors</h4>
      <p>
        Jobcast provides Services in conjunction with several payment
        processors, including Stripe and E-xact, through which users
        may pay for Jobcast memberships. Those companies acting as
        payment processors may collect and store personal data related
        to your billing information and history in order to provide
        their services and may collect and store personal data and
        business data to prevent fraud and other abuse.
      </p>
      <p>
        When you delete your Jobcast account, Jobcast deletes your
        personal data as outlined in this document. However, to delete
        your payment or billing information, you will need to do so
        with your payment provider, as Jobcast only has minimal secure
        access to those records as needed to provide the services.
      </p>
      <h4>Embedded Content</h4>
      <p>
        Jobcast posts may contain third-party embeds, which may in
        some cases collect and store personal data. The use of
        personal data by embedded content providers is not covered by
        this statement, but by the privacy policies of those sites or
        services.
      </p>
      <h4>Potential Consequences of Processing</h4>
      <p>
        By creating an account on Jobcast, users may make certain
        personal data about themselves public and accessible to others
        on their profile and through network interactions. This may in
        some cases constitute special category protected data which is
        considered manifestly made public by the user.
      </p>
      <p>
        Due to the public nature of information posted through
        Jobcast, it may be possible for third parties to derive
        identifying personal data from posts, whether by reading,
        inference, supplemental research, or automated extraction and
        analysis.
      </p>
      <p>
        Users are free to use their real name and information, or a
        pseudonym of their choosing, for their account. Users may also
        choose to use the service without posting data or engaging in
        network interactions. However, if you do not agree with and
        accept the risks of such usage, you may not use the services.
      </p>
      <h4>Cross-border Transfers</h4>
      <p>
        Jobcast is hosted in Canada. By using Jobcast services, you
        authorize Jobcast to transfer, store, and use your information
        in Canada and any other country where we operate. Where your
        data is disclosed to our processors, it is subject by contract
        to at least the same level of data protection as that set out
        in this statement.
      </p>
      <h4>Retention</h4>
      <p>
        Jobcast retains personal data associated with your account for
        the lifetime of your account. If you would like to delete your
        personal information, you can delete your account at any time.
        Upon deletion, it may take several days for your personal data
        to be de-indexed from search engines, depending on those
        search engines’ practices, over which Jobcast may have limited
        or no control.
      </p>
      <h4>Rights of Data Subjects</h4>
      <ol>
        <li>
          <p>
            If you sign up for a Jobcast account, you may at any time
            access and update your personal information from the
            Settings page.
          </p>
        </li>
        <li>
          <p>
            You may correct information associated with your account
            from the Settings page.
          </p>
        </li>
        <li>
          <p>
            You may withdraw consent by deleting your account at any
            time through the Settings page (except to the extent
            Jobcast is prevented by law from deleting your
            information).
          </p>
        </li>
        <li>
          <p>
            You may at any time lodge a complaint regarding the
            processing of your personal data by Jobcast with the
            Supervisory Authority of your EU member state.
          </p>
        </li>
      </ol>
      <p>&nbsp;</p>
    </Layout>
  )
}

export default PrivacyPage
